import { FilterIcon } from "lucide-react";

import { FilterSubMenuMultiselect } from "@/components/FilterSubMenuMultiselect";
import { Row } from "@/components/Row";
import { TableOrderByDropdown } from "@/components/TableOrderByDropdown";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import {
  placementStatusOptions,
  placementTrackerSortOptions,
} from "@/lib/constants";
import { PlacementQueryParams, PlacementStatus } from "@/types";

export const PlacementTabQueryOptions = ({
  placementQueryParams,
  setPlacementQueryParams,
}: {
  placementQueryParams: PlacementQueryParams;
  setPlacementQueryParams: (placementQueryParams: PlacementQueryParams) => void;
}) => {
  const { userOptions } = useTaggableUsers();

  return (
    <Row className="items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="h-8" variant="outlineSecondary">
            <FilterIcon className="h-4 w-4" /> Filters
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[150px] p-0">
          <DropdownMenuLabel>Filters</DropdownMenuLabel>
          <DropdownMenuSeparator className="mb-0" />
          <FilterSubMenuMultiselect
            label="Status"
            options={placementStatusOptions}
            selected={placementQueryParams.placementStatuses}
            setSelected={(statuses: PlacementStatus[]) => {
              setPlacementQueryParams({
                ...placementQueryParams,
                placementStatuses: statuses,
              });
            }}
          />
          <FilterSubMenuMultiselect
            label="Staffers"
            options={userOptions}
            selected={placementQueryParams.ownerIds}
            setSelected={(ownerIds: number[]) => {
              setPlacementQueryParams({
                ...placementQueryParams,
                ownerIds,
              });
            }}
          />
          <DropdownMenuItem
            className="p-0"
            onClick={() => {
              setPlacementQueryParams({
                ...placementQueryParams,
                placementStatuses: [],
                ownerIds: [],
              });
            }}
          >
            <DropdownMenuLabel className="font-medium">
              Clear all filters
            </DropdownMenuLabel>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <TableOrderByDropdown
        queryParams={placementQueryParams}
        setQueryParams={setPlacementQueryParams}
        sortOptions={placementTrackerSortOptions}
      />
    </Row>
  );
};
